module.exports = __webpack_public_path__ + "media/application/images/demo/boss-722ed64f5b49035bc3ea5292a76db876.jpg";